// Copyright (c) 2017 Deere & Company

import Links, {getDefaultState as getLinksDefaultState} from '../../shared/state/links';
import actions from '../../shared/actions-list';

const updateLinks = (state, action) =>
    Links.update(state, {
        $set: action.data
    });

export default (state = getLinksDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_LINKS]: updateLinks
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/app/reducers/links.js